import { Box, SxProps } from "@mui/material"
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { DateTime } from "luxon";

interface PropertySpyItemDetailChangeListTableProps {
    data?: any[]
}

export const ChangeListTable = (props: PropertySpyItemDetailChangeListTableProps): JSX.Element => {
    const {
        data
    } = props

    const gridRoot: SxProps = {
        display: 'inline-grid',
        gridTemplateColumns: 'max-content max-content max-content max-content max-content',
        gap: '20px',
        padding: '6px',
        borderRadius: `4px`,
        border: `1px solid rgba(0, 0, 0, 0.12)`,
        maxHeight: '300px',
        overflow: 'auto'
    }

    const headingStyle: SxProps = {
        fontSize: '24px',
        fontWeight: 600
    }

    const gridHeaderCellStyle: SxProps = {
        fontSize: '20px',
        fontWeight: 600,
        margin: '0 20px 0 0',
        display: 'flex',
        alignItems: 'center',
        minWidth: '110px'
    }

    const gridValueCellStyle: SxProps = {
        fontSize: '20px',
        display: 'flex',
        alignItems: 'center'
    }

    const getPropTitle = (propertyName: string): string => {
        return propertyName
    }


    const getPropOldValue = (value: string): string => {
        return value
    }

    const getValuePrefix = (propertyName: string): string => {
        if (propertyName.toLowerCase().indexOf('price') > -1) {
            return `$`
        }

        return ``
    }

    const getNewValueDirection = (oldValue: string, newValue: string): JSX.Element => {
        try {
            const oldValueInt = parseInt(oldValue)
            const newValueInt = parseInt(newValue)

            if (newValueInt > oldValueInt) {
                return (<ArrowUpwardIcon color="success"></ArrowUpwardIcon>)
            }

            if (newValueInt < oldValueInt) {
                return (<ArrowDownwardIcon color="success"></ArrowDownwardIcon>)
            }

            return (<Box sx={{
                width: '24px'
            }}></Box>)

        } catch (e) {
            return (<></>)
        }
    }

    const getFullNewValueDirection = (row: any): JSX.Element => {
        if (row.newValue === undefined || row.newValue === ``) {
            return (
                <>N/A</>
            )
        }


        const valueDirection = getNewValueDirection(row.oldValue, row.newValue)
        const prefix = getValuePrefix(row.propName)

        return (
            <>
                {valueDirection}
                {prefix}
                {row.newValue}
            </>
        )
    }

    const getFullPrevValue = (row: any): JSX.Element => {
        const prefix = getValuePrefix(row.propName)

        if (row.oldValue === undefined || row.oldValue === ``) {
            return (
                <>N/A</>
            )
        }

        return (
            <>
                {prefix}
                {row.oldValue}
            </>
        )
    }

    const renderValueList = () => {
        if (data === undefined) {
            return (<></>)
        }

        //TODO
        return data.map((row, index) => {
            return (
                <>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{getPropTitle(row.propName)}:</Box>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{getFullPrevValue(row)}</Box>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{getFullNewValueDirection(row)}</Box>
                    <Box key={Math.random()}>{DateTime.fromISO(row.timestampUtc).toFormat('M/dd/yyyy')}</Box>
                    <Box key={Math.random()}>{DateTime.fromISO(row.checkinUtc).toFormat('M/dd/yyyy')}</Box>
                </>
            )
        })
    }

    return (
        <Box>
            <Box key="changes" sx={headingStyle}>Chanfsafasges:</Box>

            <Box
                key="gridRoot"
                sx={gridRoot}
            >
                <Box key="value" sx={gridHeaderCellStyle}>Value</Box>
                <Box key="previous" sx={gridHeaderCellStyle}>Previous<br />value</Box>
                <Box key="current" sx={gridHeaderCellStyle}>Current <br />value</Box>
                <Box key="current" sx={gridHeaderCellStyle}>Found on</Box>
                <Box key="current" sx={gridHeaderCellStyle}>Time period</Box>
                {renderValueList()}
            </Box>
        </Box>
    )
}